import React from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { LeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/";
import { Button, Card } from "antd/lib";
import { selected_quote } from "../../Redux/actions/NumBikeation";
import { quick_quotes } from "../../Redux/actions/NumCaration";
import { PayHeader } from "../Paymentheader/PayHeader";
import moment from "moment";
export default function CarCompareView() {
  const history = useHistory();
  const QQCompare = useSelector((state) => state?.common?.compare);
  const QuotePost = useSelector((state) => state?.cardetail?.quickQuotePost);
  const QQuoteData = useSelector((state) => state?.cardetail?.quickquotes);

  const dispatch = useDispatch();

  const backToQQ = () => {
    history.push("/planlayout2");
    const updatedQQuoteData = QQuoteData?.map((quote, i) => {
      return { ...quote, compare: false };
    });
    console.log(updatedQQuoteData);
    dispatch(quick_quotes(updatedQQuoteData));
  };
  const handlePlan = (quote) => {
    dispatch(selected_quote(quote));
    history.push("/Customer");
  };
  return (
    <>
      <PayHeader />
      <section
        className="py-4"
        style={{ minHeight: "calc(100vh - 50px)", background: "#d8e3e899" }}
      >
        <div className="container position-relative d-flex justify-content-center">
          <div className="bc-cc-btn" onClick={backToQQ}>
            <span>
              <LeftOutlined /> Back
            </span>
          </div>

          <div className="row mt-3 px-3 col-xl-10 col-lg-12 col-md-12 col-sm-12 d-flex gap-3 justify-content-between">
            <>
              <div className="plan-card-cq-tit">
                <div className="v-name">
                  {QuotePost?.make}-{QuotePost?.model}
                  <p>Car - {QuotePost?.licensePlateNumber}</p>
                </div>
                <div className="pol-type">
                  <p>Comprehensive</p>
                </div>
                <div className="reg-date">
                  <p className="mb-0">
                    {" "}
                    Reg Date: {QuotePost?.registrationDate}
                  </p>
                  <p className="startpolicy">
                    Policy Start Date: {moment(new Date()).format("MM-DD-YYYY")}
                  </p>
                </div>
              </div>
              {QQCompare?.map((quote, index) => (
                <Card
                  key={index}
                  className="plan-card-cq col-xl-4 col-lg-12 col-md-12 col-sm-12 text-center"
                >
                  <>
                    <div className="row align-items-center">
                      <div style={{ height: "85px" }}>
                        <img
                          className="qq-view-logo"
                          src={quote?.logo}
                          alt=""
                        />
                      </div>
                    </div>
                    <p>
                      IDV ₹{" "}
                      <span>
                        {quote?.vehicle?.vehicleIDV.idv === 0
                          ? "Not Applicable"
                          : +quote?.vehicle?.vehicleIDV?.idv}
                      </span>
                    </p>
                    <div className="d-flex justify-content-center">
                      <h4
                        className="gross-txt-c"
                        onClick={() => handlePlan(quote)}
                      >
                        <span>Buy</span>₹{" "}
                        {typeof quote?.grossPremium === "string"
                          ? Math.round(
                              parseFloat(
                                quote?.grossPremium.replace(/[^\d.]/g, "")
                              )
                            )
                          : quote?.grossPremium}
                      </h4>
                    </div>
                    <p>Inc GST</p>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2 premium">
                      <div className="w-100">Premium Breakup</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">Own Damage Premium</div>
                      <div className="w-25 text-end">
                        ₹{" "}
                        {typeof quote?.coverages?.ownDamage?.traiffPremium ===
                        "string"
                          ? Math.round(
                              parseFloat(
                                quote?.coverages?.ownDamage?.traiffPremium.replace(
                                  /[^\d.]/g,
                                  ""
                                )
                              )
                            )
                          : quote?.coverages?.ownDamage?.traiffPremium}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">Third Party Premium</div>
                      <div className="w-25 text-end">₹</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">Addon Premium</div>
                      <div className="w-25 text-end">₹</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">Total Discount</div>
                      <div className="w-25 text-end">₹</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">GST</div>
                      <div className="w-25 text-end">
                        ₹{" "}
                        {typeof quote?.serviceTax?.totalTax === "string"
                          ? Math.round(
                              parseFloat(
                                quote?.serviceTax?.totalTax.replace(
                                  /[^\d.]/g,
                                  ""
                                )
                              )
                            )
                          : quote?.grossPremium}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between border-bottom p-2">
                      <div className="w-75 text-start">
                        Gross Premium (incl GST)
                      </div>
                      <div className="w-25 text-end">
                        ₹{" "}
                        {typeof quote?.grossPremium === "string"
                          ? Math.round(
                              parseFloat(
                                quote?.grossPremium.replace(/[^\d.]/g, "")
                              )
                            )
                          : quote?.grossPremium}
                      </div>
                    </div>
                  </>
                </Card>
              ))}
            </>
          </div>
        </div>
      </section>
    </>
  );
}
